import React from "react";
import * as S from "./InputStyle";
import { Button } from "reactstrap";
import T from "../../data";

const Input = (props) => {
  const showStartButton = props.showStartButton;
  const inputValue = props.inputValue;
  const onRemoveNumbersBtnClick = () => props.onRemoveNumbersBtnClick();
  const isImageTest = props.isImageTest;

  if (showStartButton) return null;

  return (
    <S.Container>
      <S.Strong>Valitud {isImageTest ? "pilt" : "numbrid"}:</S.Strong>

      <S.BootstrapInput value={inputValue} tabIndex="0" disabled />

      <Button color="secondary" size="sm" onClick={onRemoveNumbersBtnClick}>
        {T.delete}
      </Button>
    </S.Container>
  );
};

export default Input;
